export default "__VITE_ASSET__1ea70c8c__"